export const normalizeWidgetType = (widgetType) => {
  if (!widgetType || typeof widgetType !== 'string') {
    return '';
  }

  // Remove underscores and split into parts
  const parts = widgetType.split('_');

  // Convert each part to PascalCase
  return parts
    .map(part => {
      if (part.length === 0) {
        return '';
      }
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join('');
};

export const calculateJaccardSimilarity = (setA, setB) => {
  if (!Array.isArray(setA) || !Array.isArray(setB)) {
    return 0;
  }

  if (setA.length === 0 || setB.length === 0) {
    return 0;
  }

  const normalizedSetA = new Set(setA.map(normalizeWidgetType));
  const normalizedSetB = new Set(setB.map(normalizeWidgetType));

  const intersection = new Set(
    [...normalizedSetA].filter(item => normalizedSetB.has(item))
  );

  const union = new Set([...normalizedSetA, ...normalizedSetB]);

  // Jaccard similarity = |intersection| / |union|
  return intersection.size / union.size;
};

// for matching a dashboard widget set to a preset widget set
export const findBestMatchingPreset = (
  dashboardWidgets,
  presetMappings,
  minSimilarity = 0.1
) => {
  if (!Array.isArray(dashboardWidgets) || dashboardWidgets.length === 0) {
    return null;
  }

  if (!presetMappings || typeof presetMappings !== 'object') {
    return null;
  }

  const dashboardWidgetTypes = [
    ...new Set(
      dashboardWidgets
        .map(widget => widget.widget_type)
        .filter(Boolean)
    )
  ];

  if (dashboardWidgetTypes.length === 0) {
    return null;
  }

  let bestMatch = null;
  let highestSimilarity = 0;

  Object.entries(presetMappings).forEach(([presetId, presetData]) => {
    const presetWidgetTypes = presetData.widgetTypes || [];

    if (presetWidgetTypes.length === 0) {
      return;
    }

    const similarity = calculateJaccardSimilarity(
      dashboardWidgetTypes,
      presetWidgetTypes
    );

    if (similarity > highestSimilarity && similarity >= minSimilarity) {
      highestSimilarity = similarity;
      bestMatch = {
        presetId,
        similarityScore: similarity
      };
    }
  });

  return bestMatch;
};

export default {
  normalizeWidgetType,
  calculateJaccardSimilarity,
  findBestMatchingPreset
};
